// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The EntryCycle status
 */
export type EntryCycleStatus = 'draft' | 'active' | 'locked';

export const EntryCycleStatus = {
    draft: 'draft' as EntryCycleStatus,
    active: 'active' as EntryCycleStatus,
    locked: 'locked' as EntryCycleStatus
};

